import { performBulkActionForTopics, getIdAndContentTypeFromTopics, UnifiedTopic } from '@insided/control/modules/ContentModeration/utils/topic-utils'

export {
  performBulkActionForTopics,
  getIdAndContentTypeFromTopics,
  UnifiedTopic
}
